import React, { useEffect } from 'react';
import { useTheme } from '../App';

function CallbackHandler() {
  const { theme } = useTheme();
  
  useEffect(() => {
    // The logic is handled by the Cloudflare Function at `functions/callback.js`.
    // This component is just a placeholder UI during the brief redirect.
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      color: theme.colors.accentCyan,
    }}>
      Authenticating... Please wait.
    </div>
  );
}

export default CallbackHandler;